
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增项目资金支付
export function addMoneyProject(params) {
    return post(`${HOST}money-project/save`, params)
}
// 修改项目资金支付
export function updateMoneyProject(params) {
    return post(`${HOST}money-project/update`, params)
}
//项目资金支付列表
export function getMoneyProject(params) {
    return get(`${HOST}money-project/list`, params)
}
//项目资金支付草稿箱列表
export function MoneyProjectDraftlist(params) {
    return get(`${HOST}money-project/draftlist`, params)
}
//项目资金支付详情
export function MoneyProjectDetial(params) {
    return get(`${HOST}money-project/get`, params)
}
// 删除项目资金支付
export function delMoneyProject(params) {
    return del(`${HOST}money-project/delete`, params)
}







// WEBPACK FOOTER //
// ./src/views/ProjectFundApplication/api/api.js